import { envConfig } from "config";

const { appEnv, nodeEnv } = envConfig;

export const isNodeEnvTest = () => nodeEnv === "test";

export const isNodeEnvDevelopment = () => nodeEnv === "development";

export const isNodeEnvProduction = () => nodeEnv === "production";

export const isEnvLocalOnly = () => isNodeEnvDevelopment();

export const isEnvQA = () => appEnv === "qa";

export const isEnvProd = () => appEnv === "production";

export const isEnvLocalOrQA = () => isEnvLocalOnly() || isEnvQA();

/**
 * Returns `true` if the provided hostname is valid, otherwise `false`.
 */
export const isValidHostname = (hostname: string) => envConfig.allowedHostnames.includes(hostname);
